import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./Services.css";
import { Link } from "react-router-dom";
import NewsletterSection from "./NewsLetter";
import HeroSection from "./HeroSection";

const GoogleMap = ({ height = "400px" }) => {
  return (
    <div className="w-full" style={{ height }}>
      <iframe 
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3742.312974567889!2d85.85610559370357!3d20.29180778216854!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjDCsDE3JzMwLjUiTiA4NcKwNTEnMjIuMCJF!5e0!3m2!1sen!2sin!4v1599999999999!5m2!1sen!2sin"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
};

function Contact() {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    location: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div className="app">
      <Header />
      <Navbar />
      {/* <div className="service-header">
        <h1 className="font-nova-square ">Contact Us</h1>
        <p>
          <Link to={"/"}> Home </Link>{' > '} <Link to={"/contact"}>Contact Us </Link>
        </p>
      </div> */}

      {/* <div className="bg-customBlue text-white py-12">
            <div className="max-w-6xl mx-auto px-6">
              <div data-aos="fade-up" className="space-y-4 flex flex-col items-center text-center">
                <h1 className="font-nova-square text-4xl font-thin text-black">
                Contact Us
                </h1>
                <p className="text-black">
                  <Link to={"/"}> Home </Link>{' > '} <Link to={"/contact"}>Contact Us </Link> 
                </p>
              </div>
            </div>
            </div> */}

      <HeroSection 
        title="Contact Us" 
        breadcrumb={
          <>
            <Link to={"/contact"}>Contact Us</Link> 
          </>
        } 
      />


      <div className="w-full flex flex-col md:flex-row gap-8 max-w-[640px] sm:max-w-[768px] md:max-w-[1024px] lg:max-w-[1280px] xl:max-w-[1280px] 2xl:max-w-[1280px] 3xl:max-w-[1536px] 4xl:max-w-[1920px] 5xl:max-w-[2560px] 6xl:max-w-[3072px] 7xl:[3840px] mx-auto py-12 px-4 sm:px-6 md:px-8 lg:px-10">
        {/* Contact Form Section - Left 50% */}
        <div className="w-full md:w-1/2 p-4 sm:p-6 md:p-8 bg-white rounded-lg shadow-lg">
          <div className="text-center mb-6 sm:mb-8">
            <h1 className="text-2xl sm:text-3xl font-semibold text-gray-800 mb-2">Drop us a line</h1>
            <p className="text-sm sm:text-base text-gray-600">
              Please contact us using the information below. For additional information please visit the appropriate page on our site.
            </p>
          </div>

          <div className="space-y-4 sm:space-y-6">
            <form onSubmit={handleSubmit} className="space-y-3 sm:space-y-4">
              <input
                type="text"
                name="fullName"
                placeholder="Full Name"
                value={formData.fullName}
                onChange={handleChange}
                className="w-full h-10 sm:h-12 px-3 sm:px-4 py-2 text-sm sm:text-base bg-gray-100 border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
              
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                className="w-full h-10 sm:h-12 px-3 sm:px-4 py-2 text-sm sm:text-base bg-gray-100 border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
              
              <input
                type="text"
                name="location"
                placeholder="Location"
                value={formData.location}
                onChange={handleChange}
                className="w-full h-10 sm:h-12 px-3 sm:px-4 py-2 text-sm sm:text-base bg-gray-100 border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
              
              <textarea
                name="message"
                placeholder="Write.."
                value={formData.message}
                onChange={handleChange}
                rows={6}
                className="w-full px-3 sm:px-4 py-2 text-sm sm:text-base bg-gray-100 border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400 resize-none"
              />
              
              <button
                type="submit"
                className="w-full h-10 sm:h-12 px-4 py-2 text-sm sm:text-base bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-md transition-colors duration-300"
              >
                Submit
              </button>
            </form>
          </div>
        </div>

        {/* Google Maps Section - Right 50% */}
        <div className="w-full md:w-1/2 h-[300px] sm:h-[400px] md:h-[500px] lg:h-[600px] rounded-lg overflow-hidden shadow-lg">
          <GoogleMap height="100%" />
        </div>
      </div>
      
      <NewsletterSection />
      <Footer />
    </div>
  );
}

export default Contact;